import { all, put, race, select, take, takeEvery } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { getLocale, getActiveModule } from '@global/selectors'

import { GET_MINIREPORT, GET_MINIREPORT_REQUEST, MODULE_QUERIES } from './constants'
import { getMinireportRequest } from './actions'

function* minireportRequestSaga(_action) {
    const entId = _.get(_action, 'data.entId', null)
    if (!entId) return null

    const locale = yield select(getLocale)
    const activeModule = yield select(getActiveModule)
    const moduleQuery = MODULE_QUERIES?.[activeModule]

    yield all({
        response: race({
            success: take(`${GET_MINIREPORT_REQUEST}_${SUCCESS}`),
            failed: take(`${GET_MINIREPORT_REQUEST}_${FAILED}`),
        }),
        request: put(getMinireportRequest(entId, locale, moduleQuery)),
    })

    return null
}

export default function* minireportSaga() {
    yield takeEvery(GET_MINIREPORT, minireportRequestSaga)
}
